import { Blockchain } from "@rarible/api-client"
import { zilliqa } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const zilliqaConfig: StaticEthereumBlockchainConfig = {
  name: "Zilliqa",
  icon: "/images/blockchains/zilliqa.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  unionApi: "https://api.rarible.org",
  basePath: "https://zilliqa-api.rarible.org",
  chainId: zilliqa.id,
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  blockchain: Blockchain.ZILLIQA,
  chainName: zilliqa.name,
  exchange: {
    v2: "0x2c46e116a742C159fa79e2717b50759EC979e3Be",
    wrapper: "0x4421b444955b50e57fa2F73656A5bD1E23F9B9e5",
  },
  blockExplorers: [
    {
      url: "https://zilliqa.blockscout.com",
      icon: "/images/scanner.svg",
      adress: "https://zilliqa.blockscout.com/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "zilliqa-node",
  transferProxies: {
    nft: "0x892f0e3DEaC041b12b748bf9d7D1BA480d266696",
    erc721Lazy: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
    erc20: "0x12181eDedD1f81838580668bb5B50e1030df4667",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("ZILLIQA:0x0000000000000000000000000000000000000000"),
    symbol: "ZIL",
    name: "Zilliqa",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("ZILLIQA:0x94e18ae7dd5ee57b55f30c4b63e2760c09efb192"),
    symbol: "WZIL",
    name: "Wrapped Zilliqa",
    decimals: 18,
  },
  addFundsLink: "https://xbridge.zilliqa.com/",
  hasStabilityProtocol: true,
  viem: zilliqa,
}

export const getZilliqaConfig = (): StaticEthereumBlockchainConfig =>
  zilliqaConfig
